"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumOffSheetConnectorNamingRule = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const AltiumNetNamingRule_1 = require("./AltiumNetNamingRule");
class AltiumOffSheetConnectorNamingRule extends AltiumNetNamingRule_1.AltiumNetNamingRule {
    apply(group, _hierarchy) {
        if (!group.hasLabelType('off-sheet-connector')) {
            return undefined;
        }
        const offSheetConnectorNames = [];
        for (const label of group.getNetLabels()) {
            if (label.labelType === 'off-sheet-connector') {
                if (!label.formattedLabel) {
                    continue;
                }
                offSheetConnectorNames.push(label.formattedLabel);
            }
        }
        if (offSheetConnectorNames.length === 0) {
            return undefined;
        }
        offSheetConnectorNames.sort((a, b) => sigma_engine_shared_1.Utils.naturalStringSort(a, b));
        return this.dereferenceLabelName(offSheetConnectorNames[0]);
    }
}
exports.AltiumOffSheetConnectorNamingRule = AltiumOffSheetConnectorNamingRule;
//# sourceMappingURL=AltiumOffSheetConnectorNamingRule.js.map